/* 用戶相關接口 */

import request from '@/utils/http/request'

/* 用戶登錄 */
export async function login({ username, password, vercode, vertoken }) {
    return await request.post('/anon/auth/validate', {
        ia: username,
        ip: password,
        vc: vercode,
        vt: vertoken
    }, {
        noAuth: true
    });
}

/* 配置內容 */
export async function vercode() {
    return await request.get('/anon/auth/vercode', {});
}


/* 個人信息 */
export async function current_user() {
    return await request.get('/current/user', {});
}

/* 更新個人信息 */
export async function current_use_update({ avatarUrl, realname, sex }) {
    return await request.put('/current/user', { avatarUrl, realname, sex });
}

/* 更新個人密碼 */
export async function current_use_modifyPwd({ recordId, confirmPwd, originalPwd }) {
    return await request.put('/current/modifyPwd', { recordId, confirmPwd, originalPwd });
}




